<template>
  <div class="install">
    <h4 v-if="steps[step]">
      {{ partner.name }} -
      {{ step | setText(steps[step].title) }}
    </h4>
    <template v-for="(value, stepKey) in steps">
      <template v-if="step == stepKey">
        <component
          :createTransaction="createTransaction"
          :updateOrder="updateOrder"
          :transaction="transaction"
          :order="order"
          :partner="partner"
          :partner_id="partner_id"
          :is="stepKey"
          @setStep="setStep"
          :key="stepKey"
          v-model="body"
        />
      </template>
    </template>
  </div>
</template>
<script>
export default {
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  components: {
    "client-check": () => import("./ClientCheck"),
    "client-verify": () => import("./ClientVerify"),
    "client-detail": () => import("./ClientDetail"),
    "order-add": () => import("./OrderAdd"),
    done: () => import("./Done"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed &&
        this.transaction.status > -1
      );
    },
  },
  data() {
    return {
      body: null,
      step: "client-check",
      steps: {
        "client-check": {
          title: "Проверка клиента", //0
          key: "client-check",
        },
        "client-verify": {
          title: "Подтвердить смс", //0
          key: "client-verify",
        },
        "client-detail": {
          title: "Детали покупателя", //0
          key: "client-detail",
        },
        "order-add": {
          title: "Создание заказа", //2
          key: "order-add",
        },
        done: {
          title: "Завершение процесса", //3
          key: "done",
        },
      },
    };
  },
};
</script>

